import '@hotwired/turbo-rails';

window.Turbo = Turbo;